/**
 * Keeps a collection filter panel open while several values are being selected.
 *
 * Every filter change re-renders the whole collection section through the
 * Section Rendering API, and the fresh markup always arrives with the filter
 * <details> panels closed - so the panel the shopper is working in snaps shut
 * after each tick. This re-opens whichever panels were open when the update
 * started, for a short window around the re-render.
 */
(function keepFiltersOpen() {
  const RESTORE_WINDOW_MS = 3000;

  /** @type {string[]} */
  let openPanelIds = [];
  let restoreUntil = 0;

  // 'filter:update' is dispatched just before the section is re-rendered,
  // so the panels are still open at this point.
  document.addEventListener(
    'filter:update',
    () => {
      openPanelIds = Array.from(document.querySelectorAll('details.facets__panel[open]'))
        .map((panel) => panel.id)
        .filter(Boolean);
      restoreUntil = Date.now() + RESTORE_WINDOW_MS;
    },
    true
  );

  // If the shopper closes a panel themselves, stop restoring that one.
  document.addEventListener(
    'toggle',
    (event) => {
      const panel = event.target;
      if (panel instanceof HTMLDetailsElement && !panel.open && panel.id) {
        openPanelIds = openPanelIds.filter((id) => id !== panel.id);
      }
    },
    true
  );

  const restorePanels = () => {
    if (openPanelIds.length === 0 || Date.now() > restoreUntil) return;

    for (const id of openPanelIds) {
      const panel = document.getElementById(id);
      if (panel instanceof HTMLDetailsElement && !panel.open) panel.open = true;
    }
  };

  new MutationObserver(restorePanels).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
